import { EntityProperty } from '@tcc-mono/shared/data-access';
export class Hub {
  created_at?: string;
  id: number;
  name?: string;
  updated_at: string;
  properties?: EntityProperty[];
}
